import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { reconcileSessionRepository } from '@webapp/modules/accounts-payable/data-access/repositories/ReconcileSessionRepository'
import { CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/creditCardItemQueries'
import { RECONCILE_SESSION_MATCHES_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/reconcileSessionQueries'
import { STATEMENT_ITEM_UNMATCHED_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/statementItemQueries'

interface CreateMatchVariables {
  sessionId: number
  creditcardItemIds: number[]
  statementItemIds: number[]
}

export const useMutateCreateMatch = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, CreateMatchVariables>({
    mutationFn: (variables) =>
      reconcileSessionRepository.createMatch(variables),
    onSuccess: () => {
      // Triple refetch: both panes + the session's matches (BHV-034).
      queryClient.invalidateQueries({
        queryKey: CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY,
      })
      queryClient.invalidateQueries({
        queryKey: STATEMENT_ITEM_UNMATCHED_BASE_KEY,
      })
      queryClient.invalidateQueries({
        queryKey: RECONCILE_SESSION_MATCHES_BASE_KEY,
      })
    },
  })

  return {
    createMatch: mutation.mutateAsync,
    isMatching: mutation.isLoading,
    error: mutation.error,
  }
}
